<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M32 5a27 27 0 1027 27A27 27 0 0032 5zm9.55 34.42a1.51 1.51 0 01-2.13 2.13L32 34.12l-7.42 7.43a1.51 1.51 0 01-2.13-2.13L29.88 32l-7.43-7.42a1.51 1.51 0 012.13-2.13L32 29.88l7.42-7.43a1.51 1.51 0 012.13 2.13L34.12 32z"/></svg>